import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import { useSearchContext } from '@src/main/ui/providers/search/SearchContextProvider';
import { FC } from 'react';
import Highlighter from 'react-highlight-words';

interface Props {
  areas: string[];
  highlighFields?: HighlighFields[];
}

const defaultProps = {
  highlighFields: undefined,
};

const AreasCardText: FC<Props> = ({ areas, highlighFields }) => {
  const { searchInput } = useSearchContext();
  const fieldToHighligh: HighlighFields = 'areas';
  return (
    <>
      {highlighFields?.includes(fieldToHighligh) ? (
        <Highlighter searchWords={[searchInput]} textToHighlight={areas.join(' - ')} />
      ) : (
        areas.length > 0 && areas.join(' - ')
      )}
    </>
  );
};

AreasCardText.defaultProps = defaultProps;

export default AreasCardText;
